// pcaf C15 carloan
export const getScoreByType = (typeData, typeOfPattern) => {
  if (!typeData) return [null, null];

  let valueDataType2 = null;
  let dq_quality_score;
  switch (typeData) {
    case typeOfPattern.itemsDataType[0]['id']:
      dq_quality_score = 1;
      break;
    case typeOfPattern.itemsDataType[1]['id']:
    case typeOfPattern.itemsDataType[2]['id']:
      dq_quality_score = 2;
      break;
    case typeOfPattern.itemsDataType[3]['id']:
      dq_quality_score = 3;
      break;
    case typeOfPattern.itemsDataType[4]['id']:
      dq_quality_score = 4;
      break;
    case typeOfPattern.itemsDataType[5]['id']:
      dq_quality_score = 5;
      break;
  }
  return [dq_quality_score, valueDataType2];
};